import { Tabs } from '@/core/mixin/tabs'
const catchDuplicatedNavigator = error => {
  if (error.name !== 'NavigationDuplicated') {
    throw error
  }
}
export const pageJumps = {
  methods: {
    goTo(where, config) {
      const { replace = false, newTab = false } = {
        ...config
      }
      if (replace) {
        this.$router.replace(where).catch(catchDuplicatedNavigator)
        return
      }
      if (newTab) {
        const routeData = this.$router.resolve(where)
        window.open(routeData.href, '_blank')
        return
      }
      this.$router.push(where).catch(catchDuplicatedNavigator)
    },
    goToEditOrder(orderId, config) {
      this.goTo({ path: '/order/edit/' + orderId }, config)
    },
    goToCreateOrder(
      config = {
        newTab: true
      }
    ) {
      this.goTo('/order/create', config)
    },
    goToSearchOrder(query, config) {
      this.goTo({ name: 'OrderPage', query }, config)
    },
    goToSearchUnloadingOrder(query = {}, config = {}) {
      this.goTo({ path: '/order/unloading', query }, config)
    },
    goToOrderDetail(orderNo, query, config) {
      this.goTo({ path: `/order/${orderNo}`, query }, config)
    },
    goToOrderDo(orderNo, query = {}, config) {
      this.goTo({ path: `/order/do/${orderNo}`, query }, config)
    },
    goToCreateJob(
      query,
      config = {
        newTab: true
      }
    ) {
      this.goTo({ name: 'JobCreate', query }, config)
    },
    goToEditJob(
      query,
      config = {
        newTab: true
      }
    ) {
      this.goTo({ name: 'JobModify', query }, config)
    },
    goToSearchJob(query, config) {
      this.goTo({ path: '/jobs', query }, config)
    },
    goToJobDetail(jobNo, query, config) {
      this.goTo({ path: `/jobs/${jobNo}`, query }, config)
    },
    goToJobInstruction(jobId, query = {}, config) {
      this.goTo({ path: `/jobs/instruction/${jobId}`, query }, config)
    },
    goToJobLabels(jobNo, query = {}, config) {
      this.goTo({ path: `/jobs/labels/${jobNo}`, query }, config)
    },
    goToPalletSplitJob(query = {}, config = {}) {
      this.goTo({ path: '/jobs/split', query }, config)
    },
    goToQrCode(jobId, query = {}, config) {
      this.goTo({ path: `/jobs/qrcode/${jobId}`, query }, config)
    },
    goToPalletDetail(palletNo, query, config) {
      query = {
        tab: Tabs.GoodsListTab,
        ...query
      }
      this.goTo({ path: `/warehouse/pallet/${palletNo}`, query }, config)
    },
    goToPalletLabel(palletNo, query, config) {
      this.goTo({ path: `/warehouse/pallet/label/${palletNo}`, query }, config)
    },
    goToStackLabels(stackNo, query = {}, config) {
      this.goTo({ path: `/warehouse/stack/labels/${stackNo}`, query }, config)
    },
    createJob(params, config = { newTab: true }) {
      this.goTo({ name: 'JobCreate', params }, config)
    },
    searchJob(query, config) {
      this.goTo({ name: 'JobPage', query }, config)
    },
    detailPallet(palletID, query = {}, config) {
      this.goTo({ path: `/pallet/${palletID}`, query }, config)
    },
    goToStock(query, config) {
      this.goTo({ name: 'StockPage', query }, config)
    },
    goToShipmentPlace(query, config) {
      this.goTo({ name: 'ShipmentCreate', query }, config)
    },
    goToSearchShipment(query, config) {
      this.goTo({ path: '/shipment/all', query }, config)
    },
    goToSearchShipmentTruck(query, config) {
      this.goTo({ path: '/shipment/truck', query }, config)
    },
    goToShipmentDetail(shipmentNo, query, config) {
      query = {
        tab: 'PalletsTab',
        ...query
      }
      this.goTo({ path: `/shipment/${shipmentNo}`, query }, config)
    },
    goToShipmentBol(shipmentNo, query = {}, config) {
      this.goTo({ path: `/shipment/bol/${shipmentNo}`, query }, config)
    },
    goToAddress(config) {
      this.goTo({ path: '/tool/address' }, config)
    },
    goToAddressDetail(addressId, query, config) {
      this.goTo({ path: `/tool/address/${addressId}` }, config)
    },
    createUser(params, config) {
      this.goTo({ path: '/admin/user/create', params }, config)
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
